import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {Article} from "../article.model";

export class ArticleDgSearchResults extends GenericDgSearchResults {
  public results: Article[];

  constructor(total: number, results: Article[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}

